import React, { Fragment as _, useContext, useState, useEffect } from 'react';
import { interactionContext } from './interactionContext';
import EditableBtn from '../EditableBtn';
import getCurrentTopic from 'services/apiHelpers/getCurrentTopic';
import getBlockById from 'services/apiHelpers/getBlockById';
import getInteractionsInTopic from 'services/apiHelpers/getInteractionsInTopic';
import { State } from 'store/store';
import { Block } from '@chameleoncreator/creator-app';
import { useSelector, useDispatch } from 'react-redux';
import { updateAssessmentAction } from 'actions/updateAssessmentAction';
import { Box } from 'theme-ui';
import pubSub from 'services/pubSub';

const Feedback = props => {
  const context = useContext(interactionContext) as any;

  const { children: feedback } = props;

  const [showFeedback, setShowFeedback] = useState<boolean>(false);

  const [img, text, btn] = feedback.props.children;

  useEffect(() => {
    const pS = pubSub.subscribe(`SHOW_FEEDBACK_${context.id}`, $ => {
      setShowFeedback($.showFeedback);
    });
  }, []);

  if (!showFeedback) {
    return null;
  }

  return (
    <Box
      className="fader_-5s"
      sx={{
        position: 'fixed',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        left: '0px',
        top: '0px',
        width: '100%',
        height: '100%',
        padding: '120px 50px 50px 50px',
        background: '#fff',
        zIndex: 2147483647,
      }}
    >
      <Box
        className="fader_-5s"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          // left: '0px',
          // top: '0px',
          width: '100%',
          height: '100%',
          padding: '20px 40px',
          borderRadius: '50px',
          background: '#fff',
          boxShadow: '0px 0px 6px 0px rgba(0,0,0,0.15)',
        }}
      >
        <Box
          sx={{
            margin: '0 0 20px 0',
          }}
        >
          {img}
        </Box>

        {text}

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            margin: '20px 0 10px 0',
          }}
        >
          {btn}
        </Box>
      </Box>
    </Box>
  );
};

export default Feedback;
